module.exports = __webpack_public_path__ + "static/img/sy2.9f4e5102.png";